var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 4.39648C0.945312 2.18735 2.73617 0.396484 4.94531 0.396484H20.9453C23.1545 0.396484 24.9453 2.18735 24.9453 4.39648V20.3965C24.9453 22.6056 23.1545 24.3965 20.9453 24.3965H4.94531C2.73617 24.3965 0.945312 22.6056 0.945312 20.3965V4.39648Z",
    fill: "#3162AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 12.2749C8.88675 12.9595 10.7696 14.8424 11.5399 16.1262C12.4813 14.0722 14.8777 9.45054 17.4453 7.39648",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/CheckboxIcon.687c2288201fbe9f71c949508fe02ef0.svg";
export { ForwardRef as ReactComponent };